import ShortcutService from 'services/ShortcutService'

export default {
    methods: {
        invokeNextEscapeAction() {
            return this.$store.dispatch('escape-actions/invokeNext')
        },
    },

    mounted() {
        if (!this.handleEscape) {
            return
        }

        ShortcutService.bind({
            combination: 'escape',
            callback: this.handleEscape,
        })

        this.$store.dispatch('escape-actions/addOne', this.handleEscape)
    },

    beforeDestroy() {
        if (!this.handleEscape) {
            return
        }

        // Remove queued item for this particular component instance if it was not used.
        this.$store.dispatch('escape-actions/removeOne', this.handleEscape)
    },
}
